export const formatDateWithTimezone = (dateString) => {
  if (!dateString) return 'Not provided'
  const date = new Date(dateString)
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
}

export const formatTimeWithTimezone = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })
}

export const getCurrentDateForTimezone = () => {
  return new Date().toISOString()
}

export const timeAgo = (dateString) => {
  if (!dateString) return 'Unknown'
  const now = new Date()
  const date = new Date(dateString)
  const diffInSeconds = Math.floor((now - date) / 1000)
  if (diffInSeconds < 60) return 'Just now'
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`
  if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)}d ago`
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
}

export const processSubmissionsForChart = (submissions, period) => {
  if (!submissions || submissions.length === 0) return [];
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let startDate, endDate;

  switch (period) {
    case 'This Week': {
      const dayOfWeek = today.getDay(); 
      const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); 
      startDate = new Date(today.setDate(diff));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      break;
    }
    case 'Last Week': {
      const dayOfWeek = today.getDay();
      const diff = today.getDate() - dayOfWeek - 6;
      startDate = new Date(today.setDate(diff));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      break;
    }
    case 'This Month': {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;
    }
    case 'Last Month': {
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      break;
    }
    default:
      return [];
  }

  const filteredSubmissions = submissions.filter(submission => {
    const submissionDate = new Date(submission.created_at || submission.createdAt);
    return submissionDate >= startDate && submissionDate <= endDate;
  });

  if (period.includes('Week')) {
    const labels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const counts = Array(7).fill(0);
    filteredSubmissions.forEach(submission => {
      const submissionDate = new Date(submission.created_at || submission.createdAt);
      let dayIndex = submissionDate.getDay() - 1; 
      if (dayIndex === -1) {
        dayIndex = 6;
      }
      counts[dayIndex] += 1;
    });
    return labels.map((label, index) => ({
      label,
      value: counts[index] || 0
    }));
  } else {
    const daysInMonth = endDate.getDate();
    const counts = Array(daysInMonth + 1).fill(0);
    filteredSubmissions.forEach(submission => {
      const submissionDate = new Date(submission.created_at || submission.createdAt);
      counts[submissionDate.getDate()] += 1;
    });
    return Array.from({ length: daysInMonth }, (_, i) => {
      const day = i + 1;
      return {
        label: day % 2 !== 0 ? String(day) : '',
        value: counts[day] || 0
      };
    });
  }
};